var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgejo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 212",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "circle,path{fill:none;stroke:#000;stroke-width:15}path{stroke-width:25}.orange{stroke:#f60}.red{stroke:#d40000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 168V70a50 50 0 0 1 50-50h20",
    className: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 168v-30a50 50 0 0 1 50-50h20",
    className: "red"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 20,
    r: 18,
    className: "orange"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 88,
    r: 18,
    className: "red"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 180,
    r: 18,
    className: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgejo);
export default __webpack_public_path__ + "static/media/forgejo.2a8803da80097be4d2080f8cafc9b492.svg";
export { ForwardRef as ReactComponent };